<p>heatmap works!</p>

<kendo-chart>
  <kendo-chart-series>
    <kendo-chart-series-item
      type="heatmap"
      [data]="data"
      xField="a"
      yField="b"
      valueField="value"
    >
    </kendo-chart-series-item>
  </kendo-chart-series>
</kendo-chart>
